import React from 'react'
import { Link } from 'gatsby'
import { CollapsedMenu } from './collapsedMenu'

export const ExpendedMenu = ({
  isCommercialLanding,
}: {
  isCommercialLanding: boolean
}) => {
  const linkClass =
    'font-light text-primary hover:text-blue-800 transition-colors duration-300 ease-in-out w-full'

  return (
    <ul
      role="menu"
      className="px-4 py-4 space-y-4 md:px-0 lg:space-y-0 lg:space-x-4 lg:items-center lg:flex"
    >
      <li role="menuitem">
        <Link
          className={linkClass}
          to="/offres"
          title="Voir les offres d’emploi sur Lamacompta.co !"
          activeClassName="font-medium"
          rel="preload"
        >
          Offres d&apos;emploi
        </Link>
      </li>
      <li role="menuitem">
        <Link
          className={linkClass}
          to="/cabinets"
          title="Voir les cabinets sur Lamacompta.co !"
          activeClassName="font-medium"
          rel="preload"
        >
          Cabinets
        </Link>
      </li>
      {isCommercialLanding ? (
        <li role="menuitem" className="lg:hidden">
          <a
            className={linkClass}
            href="https://lamadash.fr/signup_login"
            title="Accéder à l'espace cabinet"
            target="_blank"
            rel="noreferrer"
          >
            Se connecter
          </a>
        </li>
      ) : (
        <>
          <li role="menuitem" className="lg:hidden">
            <a
              className={linkClass}
              href="https://lamadash.fr/signup_login_candidat"
              title="Accéder à l'espace candidat"
              target="_blank"
              rel="noreferrer"
            >
              Espace Candidat
            </a>
          </li>
          <li role="menuitem" className="lg:hidden">
            <Link
              className={linkClass}
              to="/je-suis-un-cabinet"
              title="Connexion / Inscription à l’Espace Cabinet Lamacompta"
            >
              Espace Cabinets
            </Link>
          </li>
        </>
      )}
      <CollapsedMenu />
    </ul>
  )
}
